module.exports = __webpack_public_path__ + "img/txt_movie.18d4c5a9.png";